module.exports = __webpack_public_path__ + "img/insure.52b85a50.svg";